import Model from 'models/Model';
import publicGetHashedStringData from './publicGetHashedStringData/Api.HashedStringStore.GetHashedStringData';

export default class HashedStringStore
  extends Model<Model.IHashedStringStore>({ icon: 'if-login' })
  implements Model.Instance<Model.IHashedStringStore>
{
  id: number;
  hashKey: string;
  originalValue: string;

  category: Model.Enum.HashedStringStoreCategory;
  algorithm: string;

  createdAtUtc: string;
  modifiedAtUtc: string;

  expiresAtUtc?: string;
  expiresAtUnix?: number;

  constructor(
    data: Partial<Model.IHashedStringStore> | Utils.FormData<Model.IHashedStringStore>,
    language?: Locale.Languages
  ) {
    super({}, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.hashKey || this.id.toString(),
    };
  }

  static async getHashedString({ hash, access_token }: Api.HashedStringStore.GetHashedStringData.IRequest) {
    const { payload, ...rest } = await publicGetHashedStringData({ hash, access_token });
    return {
      ...rest,
      payload: new HashedStringStore(payload),
    };
  }
}
